import axios from "axios";

const RESOURCE_NAME = "/auth";

export default {
  login(login, pw) {
    return axios.post(RESOURCE_NAME + "/login/", {
      username: login,
      password: pw
    });
  },
  login_code(token, code, method) {
    return axios.post(RESOURCE_NAME + "/login/code/", {
      ephemeral_token: token,
      method: method,
      code: code
    });
  },
  logout() {
    return axios.post(RESOURCE_NAME + "/logout/");
  },
  user() {
    return axios.get("/enterprise/user/");
  },
  user_pending_request() {
    return axios.get('/enterprise/userrequest/');
  },
  submit_new_email(email) {
    return axios.post('/enterprise/userrequest/', {email: email});
  },
  reset(payload) {
    return axios.post(
      "/reset_password_confirm",
      payload
    );
  },
  setPassword(user, new_password, current_password) {
    return axios.post("/enterprise/user/"+user.id+"/set_password/",
      {
        new_password: new_password,
        current_password: current_password
      });
  },
  setPasswordAdmin(user, new_password) {
    return axios.post('/office-users/'+user.id+"/set_password", {password: new_password});
  },
  requestReset(email) {
    return axios.post("/reset_password", {
      email: email
    });
  },
  mfaUserMethods() {
    return axios.get(RESOURCE_NAME + "/mfa/config/");
  },
  mfaActiveMethods() {
    return axios.get(RESOURCE_NAME + "/mfa/user-active-methods/");
  },
  requestCodeByEmail(token) {
    return axios.post(RESOURCE_NAME + "/code/fallback/request/", {
      ephemeral_token: token,
      method: "email"
    });
  },
  userlog(index) {
    var idx = index ? index: 0;
    return axios.get('/enterprise/userlog/?offset='+idx);
  },
  mfaActivateMethod(method, confirm) {
    var url = RESOURCE_NAME + '/' + method + "/activate/";
    if (confirm) {
      url += "confirm/"; 
    }
    return axios.post(url, { code: confirm});
  },
  mfaChangePrimaryMethod(method, code) {
    return axios.post(RESOURCE_NAME + "/mfa/change-primary-method/",
      {
        method : method,
        code: code
      }
    )
  },
  mfaDeactivateMethod(method) {
    return axios.post(RESOURCE_NAME + '/' + method + '/deactivate/');
  },
  mfaRequestCode(method) {
    return axios.post(RESOURCE_NAME + "/code/request/", {
      method:method
    });
  }
};
